import { render } from "./EventRegFamilyWards.vue?vue&type=template&id=de973c06&scoped=true"
import script from "./EventRegFamilyWards.vue?vue&type=script&lang=js"
export * from "./EventRegFamilyWards.vue?vue&type=script&lang=js"

import "./EventRegFamilyWards.vue?vue&type=style&index=0&id=de973c06&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de973c06"]])

export default __exports__